import { render, staticRenderFns } from "./TypicalCases.vue?vue&type=template&id=c1f546a4&scoped=true"
import script from "./TypicalCases.vue?vue&type=script&lang=js"
export * from "./TypicalCases.vue?vue&type=script&lang=js"
import style0 from "./TypicalCases.vue?vue&type=style&index=0&id=c1f546a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f546a4",
  null
  
)

export default component.exports